export default __webpack_public_path__ + "static/media/core.c2ace8bd.svg";